module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "dedication"
    }
  }, [_c('h1', [_vm._v("Dedication")]), _vm._v(" "), _c('p', [_vm._v("This book is dedicated, firstly, to our beloved and beautiful Mama Jean. She loved music without frontiers. She liked every kind of Caribbean music, along with Blues, Soul, Country, Gospel, Latin, Jazz, Classical and Vintage Rock ‘n’ Roll. Above all, she loved life, people and dance. Two of her favourite records were: ‘It Takes Two’ by Marvin Gaye and Tammi Terrell, which was played over and over again, to my delight. The other was ‘Three Steps to Heaven’ by Eddie Cochran, a charming slice of teen beat rock ‘n’ roll, but the lad didn’t know one thing: in rehab, there are twelve steps to Heaven.")]), _vm._v(" "), _c('p', [_vm._v("To Mamie, my maternal grandmother and spiritual guide; and to our beloved sister Verina who recently departed from this world, and last, but not least, to all suffering and recovering drug and alcohol addicts and their families, throughout the world.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c22c3d46","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/ch002.vue
// module id = 66
// module chunks = 0